// Color System for DigiTrek
export const colors = {
  // Primary Colors
  primary: {
    50: '#F7FAFD',
    100: '#E2EFF8',
    500: '#3D94D0',
    750: '#1C4F73',
    800: '#17415E',
    950: '#081721',
  },
  
  // Neutral Colors
  neutral: {
    6: '#141218',
    20: '#313030',
    30: '#484646',
    50: '#797676',
    70: '#ADAAAA',
    80: '#C9C6C5',
    90: '#E5E1E1',
    95: '#F4F0EF',
    100: '#FFFFFF',
  },
  
  // Background Colors
  background: {
    dark: '#191A1A',
    black: '#000000',
    darkBlue: '#002138',
    white: '#FFFFFF',
    lightGray: '#F5F5F5',
  },
  
  // Gradient Colors
  gradient: {
    darkBlue: 'linear-gradient(180deg, rgba(14, 29, 39, 0) 0%, #07141D 21.59%, #000000 45%)',
  },
  
  // Process Cards
  process: {
    card1: '#E2EFF8',
    card2: '#8DA7BB',
    card3: '#7099BE',
    card4: '#E2EFF8',
  },
  
  // Accent Colors (from icons)
  accent: {
    orange: '#E36414',
    yellow: '#FFC970',
    red: '#DB3429',
    darkRed: '#B3271E',
    blue: '#1F3E75',
    lightBlue: '#1ABCFE',
    green: '#0ACF83',
    purple: '#A259FF',
    pink: '#FF7262',
    figmaRed: '#F24E1E',
  },
};


